const serviceData = [
  {
    title: 'Luxury Branding',
    tagLine: 'Turn your brand into an unforgettable digital icon.',
    subTitle: 'Positioning your brand at the intersection of prestige and purpose.',
    icon: 'FaGem',
    // color: '#f46e10',
    color: '#588157',
    description: 'We work closely with you to build a distinctive digital identity that reflects your values, elevates perception, and resonates with discerning audiences. From strategic positioning to visual storytelling, we ensure every touchpoint reinforces the essence of your brand.',
    points: [
      'Brand strategy and narrative development', 
      'Visual identity and digital presence', 
      'High-impact brand experiences', 
      'Tone of voice and communication design'
    ],
  },
  {
    title: 'Elite Design',
    tagLine: 'Where minimalist beauty meets flawless usability.',
    subTitle: 'Where elegance meets usability',
    icon: 'FaCrown',
    // color: 'purple',
    color: '#c08497',
    description: 'Our design approach combines minimalist aesthetics with user-focused functionality. Every interface we craft is tailored to deliver intuitive experiences—balancing visual appeal with practical performance across devices and platforms.',
    points: [
      'UI/UX for high-end digital products', 
      'Responsive, accessible, and scalable designs', 
      'Prototyping and interaction design', 
      'Custom design systems and frameworks'
    ],
  },
  {
    title: 'Bespoke Applications',
    tagLine: 'Custom-built solutions that scale with your ambition',
    subTitle: 'Precision-engineered software, built around your vision.',
    icon: 'FaLaptop',
    color: '#246a73',
    // color: '#58e29e',
    description: 'We develop fully customized applications that solve complex problems with simplicity and performance. From sleek MVPs to enterprise-grade systems, our solutions are built to scale—and designed to impress.',
    points: [
      'Full-stack product development',
      'MVP strategy and rapid prototyping',
      'Secure, scalable, cloud-native solutions',
      'Long-term maintenance and technical consulting',
    ],
  },
];

module.exports = {serviceData}